"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
var helios_styles_1 = require("@carvana/helios-styles");
var styled_components_1 = require("styled-components");
var labels = ['xs', 'sm', 'md', 'lg'];
var label = labels.reduce(function (bodyObj, bodySize) {
    var _a;
    return (__assign(__assign({}, bodyObj), (_a = {}, _a[bodySize] = (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      font-family: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n      font-size: ", ";\n      letter-spacing: ", ";\n      text-decoration: ", ";\n    "], ["\n      font-family: ", ";\n      font-weight: ", ";\n      line-height: ", ";\n      font-size: ", ";\n      letter-spacing: ", ";\n      text-decoration: ", ";\n    "])), helios_styles_1.label[bodySize].fontFamily, helios_styles_1.label[bodySize].fontWeight, helios_styles_1.label[bodySize].lineHeight, helios_styles_1.label[bodySize].fontSize, helios_styles_1.label[bodySize].letterSpacing, helios_styles_1.label[bodySize].textDecoration), _a)));
}, {});
exports.default = label;
var templateObject_1;
